import { Theme } from '@material-ui/core/styles';

const styles = (theme: Theme) => ({
  editor: {
    '@global .DraftEditor-root': {
      fontSize: 14,
      fontWeight: theme.typography.fontWeightBold,
    },
    '@global .DraftEditor-editorContainer': {
      padding: '7px 8px 8px 7px',
      border: `1px solid ${theme.palette.grey[300]}`,
      borderRadius: theme.spacing(2),
      backgroundColor: theme.custom.palette.grey4,
    },
    '@global .public-DraftEditorPlaceholder-root': {
      paddingLeft: 10,
      top: '50%',
      transform: 'translateY(-50%)',
      color: theme.palette.text.primary,
      opacity: 0.42, // matches text input style
      fontFamily: theme.typography.fontFamily,
      fontWeight: theme.typography.fontWeightRegular,
      zIndex: 2,
      'pointer-events': 'none',
    },
  },
});

export default styles;
